import ReactGA from 'react-ga';
import Utils from 'common/utils'
import VersionManager from 'manager/versionManager';
import Network from 'common/network'

const analyticsEvents = [];
const analyticsBufferThreshold = 50
var analyticsBaseUrl = "https://loggerpro-a.akamaihd.net/log?"
var storeId = "weatherport-internal";
var os = 'android';
var domain = 'weatherport.co';
var productName = "weather-port-internal";
var extFamily = 'launcher';
var product = "weather";
var affiliate_id = "test"
var tId = 1;
var se1 = 1;
var productType;
var defaultParams = []
var analyticsEventsUrl;
var evtid = "sparta";
var eventValue = 1;
var appId = "test";

const mapObjToEventProperties = (obj, eventObj) => {
    if (!obj) {
        return;
    }
    for (let [key, value] of Object.entries(obj)) {
        if (key && value) eventObj.addProperty(key, value)
    }
}
export default class Analytics {
    static initialise() {
        // The default values are prod-values
        let id = process.env.REACT_APP_DEBUG_ANALYTICS_ID;
        let opts = null
        console.info("Flavour : " + process.env.REACT_APP_DEPLOY_ENV + " " + process.env.REACT_APP_FLAVOR);

        if (process.env.REACT_APP_FLAVOR === "INTERNAL_STAGING") {
            // Set the debug values here.
            console.info("using staging flavour GA");
            id = process.env.REACT_APP_DEBUG_ANALYTICS_ID;
            analyticsBaseUrl = process.env.REACT_APP_ANALYTICS_BASE_URL_INTERNAL;
            console.log("analytics url:" + analyticsBaseUrl);
            // NOTE: This set of options is required to increase sampling-rate. We increase the
            // sampling rate so that analytics can give better insights on speed. It is usually at 1%.
            // Uncomment this only on testing. anThis should NOT be in prod!
            opts = {
                gaOptions: {
                    // https://stackoverflow.com/a/24813500/1518924
                    siteSpeedSampleRate: 100
                }
            }
            productType = 'weather-web-app-iternal';
        } else if (process.env.REACT_APP_FLAVOR === "WEATHER_KEY") {
            console.info("using WEATHER_KEY flavour GA");
            id = process.env.REACT_APP_PROD_ANALYTICS_ID_WEATHER_KEY;
            analyticsBaseUrl = process.env.REACT_APP_ANALYTICS_BASE_URL_WEATHER_KEY;
            storeId = 'com.weatherkey.android';
            productName = 'weatherkey';
            domain = 'weatherkey.co';
            productType = 'web-app-weather-key';
            affiliate_id = "tagJ956790-weather"
            appId = 13185
        } else if (process.env.REACT_APP_FLAVOR === "WEATHER_BAY") {
            console.info("using WEATHER_BAY flavour GA");
            id = process.env.REACT_APP_PROD_ANALYTICS_ID_WEATHER_BAY;
            analyticsBaseUrl = process.env.REACT_APP_ANALYTICS_BASE_URL_WEATHER_BAY;
            storeId = 'com.weatherbay.android';
            productName = 'weatherbay';
            domain = 'weatherbay.co';
            productType = 'web-app-weather-bay';
            affiliate_id = "tagO1331743-weather"
            appId = 13193
        } else if (process.env.REACT_APP_FLAVOR === "WEATHER_PORT") {
            console.info("using WEATHER_PORT flavour GA");
            id = process.env.REACT_APP_PROD_ANALYTICS_ID_WEATHER_PORT;
            analyticsBaseUrl = process.env.REACT_APP_ANALYTICS_BASE_URL_WEATHER_PORT;
            productName = 'weatherport';
            storeId = 'com.weatherport.android';
            domain = 'weatherport.co';
            productType = 'web-app-weather-port';
            affiliate_id = "tagJ955353-weather"
            appId = 13097
        }

        //Adding default analytics param
        defaultParams['product_name'] = productName;
        defaultParams['ext_family'] = extFamily;
        defaultParams['product'] = product;
        defaultParams['domain'] = domain;
        defaultParams['store_id'] = storeId;
        defaultParams['os'] = os;
        defaultParams['se1'] = se1;
        defaultParams['tid'] = tId;
        defaultParams['product-type'] = productType;
        defaultParams['logid'] = 'kfk';
        defaultParams['evtid'] = evtid;
        defaultParams['event_value'] = eventValue;
        defaultParams['appid'] = appId;



        //Generate analytics usl with default params
        analyticsEventsUrl = analyticsBaseUrl + this.encodeQueryData(defaultParams)
        ReactGA.initialize(
            id,
            opts,
        );
        ReactGA.set({ appVersion: VersionManager.getAppVersion() })
        ReactGA.pageview(window.location.pathname);
    }

    static getAnalyticsInstance() {
        return ReactGA;
    }

    /**
     * Sends an event to analytics. All the optional entries can be set to null.
     * @param {string} category
     * @param {string} action
     * @param {string|null} label
     * @param {int|null} value
     * @param {bool|null} nonInteraction
     * @param {string|null} transport
     */
    static sendEvent(category, action, label, value, nonInteraction, transport) {
        if (Utils.isEmptyStr(category) || Utils.isEmptyStr(action)) {
            return null
        }

        let opts = {
            category: category,
            action: action,
        }

        if (false === Utils.isEmptyStr(label)) {
            opts.label = label;
        }

        if (false === Utils.isNull(value)) {
            opts.value = value;
        }

        if (false === Utils.isNull(transport)) {
            opts.transport = transport;
        }

        if (false === Utils.isNull(nonInteraction)) {
            opts.nonInteraction = nonInteraction;
        }

        this.sendToAnalytics(opts);

        ReactGA.event(opts)
        return true
    }

    static sendEventWithObjParams(obj) {
        let opts = {
            category: obj.category,
            action: obj.action,
        }

        if (false === Utils.isEmptyStr(obj.label)) {
            opts.label = obj.label;
        }

        if (false === Utils.isNull(obj.value)) {
            opts.value = obj.value;
        }

        if (false === Utils.isNull(obj.transport)) {
            opts.transport = obj.transport;
        }

        if (false === Utils.isNull(obj.nonInteraction)) {
            opts.nonInteraction = obj.nonInteraction;
        }
        this.sendToAnalytics(obj);
        ReactGA.event(opts)
        return true
    }

    /**
     * Send page-url as page-view
     * @param {string} page
     */
    static trackPageView(page) {
        if (Utils.isEmptyStr(page)) {
            return false
        }

        // Add the version details as well
        ReactGA.set({
            page: page
        })

        ReactGA.pageview(page)
        return true
    }

    /**
     * Set the user-id in the analytics store
     * @param {string} userId
     */
    static setUserId(userId) {
        if (Utils.isEmptyStr(userId)) {
            return false
        }
        console.log("setting user id: " + userId);
        this.userId = userId;
        ReactGA.set({ userId: userId })
        return true
    }

    /**
     * Set the aff_id in the analytics store
     * @param {string} affId
     */
    static setAffiliateId(affId) {
        if (Utils.isEmptyStr(affId)) {
            return false
        }
        affiliate_id = affId;
        return true
    }

    static sendToAnalytics(opts) {
        var event = Event.newEvent(opts.action);
        event.addProperty("sun", affiliate_id);
        mapObjToEventProperties(opts, event)
        console.log('event', event)
        if (this.isUserIdSelfGenerated()) {
            this.pushToAnalyticsBuffer(event);
        } else {
            this.sendSingleEvent(event);
            if (analyticsEvents.length !== 0) {
                this.syncAnalyticsBuffer();
            }
        }
    }


    static sendSingleEvent(event) {
        event.addProperty("user_id", this.userId);
        event.addProperty("sun", affiliate_id);
        //Add the runtime params to url
        let url = analyticsEventsUrl + '&' + this.encodeQueryData(event.properties);
        console.log("event: " + url);
        Network.fetchWithTimeout(url)
            .then((response) => {
                if (Utils.isNull(response) || false === response.ok) {
                    analyticsEvents.push(event);
                }
            })
            .catch((e) => {
                console.log(e);
            })
    }

    static encodeQueryData(data) {
        const ret = [];
        for (let d in data)
            ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
        return ret.join('&');
    }


    static syncAnalyticsBuffer() {
        while (analyticsEvents.length !== 0) {
            this.sendSingleEvent(analyticsEvents.shift());
        }
    }

    static isUserIdSelfGenerated() {
        return Utils.isEmptyStr(this.userId) || this.userId.includes("custom")
    }

    static pushToAnalyticsBuffer(event) {
        if (analyticsEvents.length >= analyticsBufferThreshold) {
            analyticsEvents.shift();
        }

        analyticsEvents.push(event);
    }
}

class Event {
    constructor(name) {
        this.properties = [];
        this.properties['event_name'] = name;
        this.properties['e_time'] = Date.now();
    }

    static newEvent(name) {
        return new Event(name);
    }

    addProperty(key, value) {
        this.properties[key] = value;
    }
}



// WEBPACK FOOTER //
// ./src/analytics.js